import React, { useState, useEffect } from "react";
import { StripeSavePaymentMethodContainer } from "../Payment/StripeContainer"

function Subscription({ updateProducts, updateTotalAmount }) {

  return <StripeSavePaymentMethodContainer />
}

export default Subscription